import QRCode from "qrcode.react";

const QRPart = ({ idValue, qrUrl, iconSrc = "/images/qr-code.svg", tooltip = "Download QR Code" }) => {
  const downloadQR = () => {
    const canvas = document.getElementById(idValue);
    if (!canvas) return;

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${idValue}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      <button
        className="uk-button"
        type="button"
        uk-tooltip={tooltip}
        onClick={downloadQR}
      >
        <img src={iconSrc} alt="Download QR" />

        <QRCode
          hidden={true}
          id={idValue}
          bgColor="white"
          value={qrUrl}
          title="QRcodeForHome"
          style={{ border: "6px solid white" }}
          level="H"
          includeMargin={true}
          size={256}
        />
      </button>
    </>
  );
};

export default QRPart;